export const aircraftHeader = [
    {
        prop: 'id',
        label: '序号',
        sortable: false
    },
    {
        prop: 'series',
        label: '飞行器编号',
        sortable: false
    },
    {
        prop: 'subordinateCompany',
        label: '所属公司',
    },
    {
        prop: 'deviceNumber',
        label: '设备号',
    },
    {
        prop: 'deviceMmsi',
        label: 'MMSI号',
    },
    {
        prop: 'avionicsPower',
        label: '航电系统电量',
    },
    {
        prop: 'region',
        label: '所属区域',
    },
    {
        prop: 'createTime',
        label: '录入时间',
    },
    {
        prop: 'updateTime',
        label: '最后定位时间',
    },
    {
        prop: 'operations',
        label: '操作',
        btns: [
            {
                name: '查看',
                type: 'view'
            },
            {
                name: '编辑',
                type: 'edit'
            },
            {
                name: '删除',
                type: 'delete'
            }
        ]
    },
]
export const facilityTypeHeader = [
    {
        prop: 'id',
        label: '序号',
        sortable: false
    },
    {
        prop: 'name',
        label: '设施设备类型',
        sortable: false
    },
    {
        prop: 'isRange',
        label: '是否有范围',
    },
    {
        prop: 'pictures',
        label: '图标',
    },
    {
        prop: 'operations',
        label: '操作',
        btns: [
            {
                name: '编辑',
                type: 'edit'
            },
            {
                name: '删除',
                type: 'delete'
            }
        ]
    },
]
export const facilityDataHeader = [
    {
        prop: 'id',
        label: '序号',
        sortable: false
    },
    {
        prop: 'name',
        label: '设施设备名称',
        sortable: false
    },
    {
        prop: 'typeName',
        label: '设施设备类型',
        sortable: false
    },
    {
        prop: 'lonLat',
        label: '坐标',
    },
    {
        prop: 'radius',
        label: '覆盖范围(海里)',
    },
    {
        prop: 'operations',
        label: '操作',
        btns: [
            {
                name: '编辑',
                type: 'edit'
            },
            {
                name: '删除',
                type: 'delete'
            }
        ]
    },
]
export const groundResourcesTypeHeader = [
    {
        prop: 'id',
        label: '序号',
        sortable: false
    },
    {
        prop: 'name',
        label: '地面资源类型',
        sortable: false
    },
    {
        prop: 'pictures',
        label: '图标',
        sortable: false
    },
    {
        prop: 'operations',
        label: '操作',
        btns: [
            {
                name: '编辑',
                type: 'edit'
            },
            {
                name: '删除',
                type: 'delete'
            }
        ]
    },
]
export const groundResourcesDataTypeHeader = [
    {
        prop: 'id',
        label: '序号',
        sortable: false
    },
    {
        prop: 'name',
        label: '地面资源名称',
        sortable: false
    },
    {
        prop: 'typeName',
        label: '地面资源类型',
        sortable: false
    },
    {
        prop: 'lonLat',
        label: '坐标',
        sortable: false
    },
    {
        prop: 'operations',
        label: '操作',
        btns: [
            {
                name: '编辑',
                type: 'edit'
            },
            {
                name: '删除',
                type: 'delete'
            }
        ]
    },
]
export const airspaceHeader = [
    {
        prop: 'id',
        label: '序号',
        sortable: false
    },
    {
        prop: 'classify',
        label: '空域类型',
        sortable: false
    },
    {
        prop: 'name',
        label: '空域围栏名称',
        sortable: false
    },
    {
        prop: 'availableDate',
        label: '有效时间',
        sortable: false
    },
    {
        prop: 'range',
        label: '空域围栏范围',
        sortable: false
    },
    {
        prop: 'enabled',
        label: '是否启动',
        sortable: false
    },
    {
        prop: 'modifyTime',
        label: '最后操作时间',
        sortable: false
    },
    {
        prop: 'operations',
        label: '操作',
        btns: [
            {
                name: '查看',
                type: 'view'
            },
            {
                name: '编辑',
                type: 'edit'
            },
            {
                name: '删除',
                type: 'delete'
            }
        ]
    },
]
export const airApproachControlHeader = [
    {
        prop: 'id',
        label: '序号',
        sortable: false
    },
    {
        prop: 'name',
        label: '航线名称',
        sortable: false
    },
    {
        prop: 'routeSer',
        label: '航线编号',
        sortable: false
    },
    {
        prop: 'startStationName',
        label: '起始航站',
        sortable: false
    },
    {
        prop: 'endStationName',
        label: '终点航站',
        sortable: false
    },
    {
        prop: 'stationsArr',
        label: '停靠站点',
        sortable: false
    },
    {
        prop: 'routeDistance',
        label: '航线长度',
        sortable: false
    },
    {
        prop: 'checkStatus',
        label: '审核状态',
        sortable: false
    },
    {
        prop: 'modifyTime',
        label: '最后操作时间',
        sortable: false
    },
    {
        prop: 'operations',
        label: '操作',
        btns: [
            {
                name: '查看',
                type: 'view'
            },
            // {
            //     name: '编辑',
            //     type: 'edit'
            // },
            // {
            //     name: '删除',
            //     type: 'delete'
            // }
        ]
    },
]
export const airlineEnquiryHeader = [
    {
        prop: 'id',
        label: '序号',
        sortable: false
    },
    {
        prop: 'startStationName',
        label: '起始航空站',
        sortable: false
    },
    {
        prop: 'endStationName',
        label: '终点航空站',
        sortable: false
    },
    {
        prop: 'createDate',
        label: '创建时间',
        sortable: false
    },
    {
        prop: 'stationsArr',
        label: '停靠站点',
        sortable: false
    },
    {
        prop: 'routeDistance',
        label: '航线长度',
        sortable: false
    },
    {
        prop: 'operations',
        label: '操作',
        btns: [
            {
                name: '查看',
                type: 'view'
            }
        ]
    },
]
export const emergencyHeader = [
    {
        prop: 'id',
        label: '序号',
        sortable: false
    },
    {
        prop: 'flyMachineSer',
        label: '飞行器编号',
        sortable: false
    },
    {
        prop: 'rescueTime',
        label: '发起救援时间',
        sortable: false
    },
    {
        prop: 'lonLat',
        label: '发起救援时坐标',
        sortable: false
    },
    {
        prop: 'reasons',
        label: '发起救援原因',
        sortable: false
    },
    {
        prop: 'status',
        label: '救援状态',
        sortable: false
    },
    {
        prop: 'machineNames',
        label: '可调配救援资源',
        sortable: false
    },
    {
        prop: 'markRescue',
        label: '发起救援备注',
        sortable: false
    },
    {
        prop: 'markResult',
        label: '救援结果备注',
        sortable: false
    },
    {
        prop: 'operations',
        label: '操作',
        btns: [
            {
                name: '删除',
                type: 'delete'
            }
        ]
    },
]
export const alarmHeader = [
    {
        prop: 'id',
        label: '序号',
        sortable: false
    },
    {
        prop: 'flyMachineSer',
        label: '飞行器编号',
        sortable: false
    },
    {
        prop: 'warningTime',
        label: '告警时间',
        sortable: false
    },
    {
        prop: 'warningClass',
        label: '告警类型',
        sortable: false
    },
    {
        prop: 'lonLat',
        label: '触发告警时坐标',
        sortable: false
    },
    {
        prop: 'status',
        label: '处理状态',
        sortable: false
    },
    {
        prop: 'dealedPeople',
        label: '处理人',
        sortable: false
    },
    {
        prop: 'dealedTime',
        label: '处理时间',
        sortable: false
    },
    {
        prop: 'operations',
        label: '操作',
        btns: [
            // {
            //     name: '处理',
            //     type: 'dispose'
            // },
            // {
            //     name: '查看处理结果',
            //     type: 'delete'
            // }
        ]
    },
]
export const roleHeader = [
    {
        prop: 'id',
        label: '序号',
        sortable: false
    },
    {
        prop: 'name',
        label: '角色名',
        sortable: false
    },
    {
        prop: 'countPermissions',
        label: '权限数',
        sortable: false
    },
    {
        prop: 'disabled',
        label: '状态',
        sortable: false
    },
    {
        prop: 'createTime',
        label: '创建时间',
        sortable: false
    },
    {
        prop: 'operName',
        label: '操作人',
        sortable: false
    },
    {
        prop: 'updateTime',
        label: '更新时间',
        sortable: false
    },
    {
        prop: 'operations',
        label: '操作',
        btns: [
            {
                name: '编辑',
                type: 'edit',
                permission: 'PC-角色管理:编辑'
            },
            {
                name: '删除',
                type: 'delete',
                permission: 'PC-角色管理:删除'
            }
        ]
    },
]
export const systemUserHeader = [
    {
        prop: 'id',
        label: '序号',
        sortable: false
    },
    {
        prop: 'username',
        label: '用户账号',
        sortable: false
    },
    {
        prop: 'authenticatedName',
        label: '认证名称',
        sortable: false
    },
    {
        prop: 'roleName',
        label: '角色',
        sortable: false
    },
    {
        prop: 'disabled',
        label: '状态',
        sortable: false
    },
    {
        prop: 'createTime',
        label: '创建时间',
        sortable: false
    },
    {
        prop: 'authenticated',
        label: '是否认证',
        sortable: false
    },
    {
        prop: 'formattedSource',
        label: '用户来源',
        sortable: false
    },
    {
        prop: 'updateTime',
        label: '更新时间',
        sortable: false
    },
    {
        prop: 'operations',
        label: '操作',
        btns: [
            {
                name: '编辑',
                type: 'edit',
                permission: 'PC-用户管理:更新'
            }
        ]
    },
]
export const enterpriseCertificationHeader = [
    {
        prop: 'id',
        label: '序号',
        sortable: false
    },
    {
        prop: 'userName',
        label: '用户账号',
        sortable: false
    },
    {
        prop: 'authenticatedName',
        label: '申请人',
        sortable: false
    },
    {
        prop: 'classify',
        label: '认证类型',
        sortable: false
    },
    {
        prop: 'company',
        label: '所属企业',
        sortable: false
    },
    {
        prop: 'idCardNum',
        label: '身份证代码',
        sortable: false
    },
    {
        prop: 'mark',
        label: '认证失败原因',
        sortable: false
    },
    {
        prop: 'createTime',
        label: '申请认证时间',
        sortable: false
    },
    {
        prop: 'status',
        label: '认证状态',
        sortable: false
    },
    {
        prop: 'updateTime',
        label: '更新时间',
        sortable: false
    },
    {
        prop: 'operations',
        label: '操作',
        btns: [
            // {
            //     name: '审核',
            //     type: 'audit'
            // },
            {
                name: '查看',
                type: 'view'
            },
        ]
    },
]
export const pilotCertificationHeader = [
    {
        prop: 'id',
        label: '序号',
        sortable: false
    },
    {
        prop: 'userName',
        label: '用户账号',
        sortable: false
    },
    {
        prop: 'authenticatedName',
        label: '申请人',
        sortable: false
    },
    {
        prop: 'company',
        label: '所属企业',
        sortable: false
    },
    {
        prop: 'idCardNum',
        label: '身份证代码',
        sortable: false
    },
    {
        prop: 'mark',
        label: '认证失败原因',
        sortable: false
    },
    {
        prop: 'createTime',
        label: '申请认证时间',
        sortable: false
    },
    {
        prop: 'status',
        label: '认证状态',
        sortable: false
    },
    {
        prop: 'updateTime',
        label: '更新时间',
        sortable: false
    },
    {
        prop: 'operations',
        label: '操作',
        btns: [
            // {
            //     name: '审核',
            //     type: 'audit'
            // },
            {
                name: '查看',
                type: 'view'
            },
        ]
    },
]
export const navigationPointHeader = [
    {
        prop: 'name',
        label: '导航点',
        sortable: false
    },
    {
        prop: 'lon',
        label: '经度',
        sortable: false
    },
    {
        prop: 'lat',
        label: '纬度',
        sortable: false
    },
]
export const flightPlanManagementHeader = [
    {
        prop: 'flyMachineSer',
        label: '飞行器编号',
        sortable: false
    },
    {
        prop: 'planSer',
        label: '计划编号',
        sortable: false
    },
    {
        prop: 'planClass',
        label: '计划类型',
        sortable: false
    },
    {
        prop: 'startStation',
        label: '起始站',
        sortable: false
    },
    {
        prop: 'endStation',
        label: '终点站',
        sortable: false
    },
    {
        prop: 'flyDate',
        label: '执飞日期',
        sortable: false
    },
    {
        prop: 'launchTime',
        label: '预计起飞',
        sortable: false
    },
    {
        prop: 'landTime',
        label: '预计降落',
        sortable: false
    },
    {
        prop: 'hight',
        label: '高度',
        sortable: false
    },
    {
        prop: 'status',
        label: '审核状态',
        sortable: false
    },
    {
        prop: 'operations',
        label: '操作',
        btns: [
            {
                name: '查看',
                type: 'view'
            }
        ]
    },
]
export const satelliteManagementHeader = [
	{
		
		prop: 'findDate',
		label: '发现时间',
		sortable: false
	},
	{
		prop: 'fireType',
		label: '类型',
		sortable: false
	},
	// {
	// 	prop: 'checkType',
	// 	label: '核查状态',
	// 	sortable: false
	// },
	{
		prop: 'reliability',
		label: '可信度',
		sortable: false
	},
	{
		prop: 'fireStatus',
		label: '热源状态',
		sortable: false
	},
	{
		prop:"location",
		label:"地址",
		sortable: false
	},
	{
		prop:"lonLat",
		label:"经纬度",
		sortable: false
	},
	{
		prop:"remark",
		label:"数据来源",
		sortable: false
	},
	{
		prop:"origin",
		label:"来源类型",
		sortable: false
	},
	
	
]